import templateUrl from './businessWorkflowFilter.tpl.html';

export default {
    templateUrl,
    bindings: {
        emptyText: '<',
        environment: '<',
        hideLabel: '<',
        isMultiSelect: '<',
        label: '<',
        apmVersion: '<',
        useTransactionTerminology: '<',
    },
    controller: [
        '$element',
        '$timeout',
        'routeParameterService',
        'BusinessWorkflowSelection',
        'urlOverridesService',
        function (
            $element,
            $timeout,
            routeParameterService,
            BusinessWorkflowSelection,
            urlOverridesService
        ) {
            const $ctrl = this;

            let unregisterRouteWatcher;

            $ctrl.editMode = false;
            // Note: it does not work for $onChange()
            // because we dont update it in some of the modifying methods (ex: onRemove, onUpdate..)
            // if we need to support $onChange() on this, we need to make updates on the modifying methods
            $ctrl.selectedFilters = [];

            // lifecycle bindings
            $ctrl.$onInit = $onInit;
            $ctrl.$onDestroy = $onDestroy;

            // callback functions
            $ctrl.enableEditMode = enableEditMode;
            $ctrl.onAddButtonKeydown = onAddButtonKeydown;
            $ctrl.onSelect = onSelect;
            $ctrl.onUpdate = onUpdate;
            $ctrl.onRemove = onRemove;
            $ctrl.onBlurInput = onBlurInput;
            $ctrl.onBlurDefaultInput = onBlurDefaultInput;

            function $onInit() {
                unregisterRouteWatcher = routeParameterService.registerRouteWatch(
                    'businessWorkflows[]',
                    updateFiltersFromUrl
                );

                updateFiltersFromUrl();
            }

            function $onDestroy() {
                unregisterRouteWatcher();
            }

            function enableEditMode() {
                $ctrl.editMode = true;

                focusOnDefaultSelector();
            }

            function onAddButtonKeydown($event) {
                if ($event.key !== 'Tab') {
                    enableEditMode();
                }
            }

            function onSelect(businessWorkflowSelection) {
                const id = businessWorkflowSelection.getId();
                if ($ctrl.selectedFilters.some((f) => f.getId() === id)) return;

                $ctrl.selectedFilters.push(businessWorkflowSelection);
                urlOverridesService.setBusinessWorkflows($ctrl.selectedFilters);
                disableEditMode();
            }

            function onUpdate(selection, index) {
                $ctrl.selectedFilters[index].copyProperties(selection);

                const filterIds = new Set();
                $ctrl.selectedFilters = $ctrl.selectedFilters.filter((f) => {
                    const id = f.getId();
                    if (!filterIds.has(id)) {
                        filterIds.add(id);
                        return true;
                    }
                });

                urlOverridesService.setBusinessWorkflows($ctrl.selectedFilters);
                disableEditMode();
            }

            function onRemove(index) {
                $ctrl.selectedFilters.splice(index, 1);
                urlOverridesService.setBusinessWorkflows($ctrl.selectedFilters);
            }

            function onBlurInput(businessWorkflowSelection) {
                if (!businessWorkflowSelection.isComplete()) {
                    $ctrl.selectedFilters = $ctrl.selectedFilters.filter((f) => f.isComplete());
                }
            }

            function onBlurDefaultInput() {
                disableEditMode();
            }

            //------------------------------------------------------------------
            // Private methods
            //------------------------------------------------------------------

            function disableEditMode() {
                $ctrl.editMode = false;
            }

            function focusOnDefaultSelector() {
                $timeout(() => {
                    const inputBox = $element.find(
                        '.business-workflow-filter-default-selector input'
                    )[0];
                    if (inputBox) {
                        inputBox.click();
                    }
                }, 0);
            }

            function updateFiltersFromUrl() {
                $ctrl.selectedFilters = urlOverridesService
                    .getBusinessWorkflows()
                    .map(
                        (businessWorkflow) =>
                            new BusinessWorkflowSelection(businessWorkflow.resource)
                    );
            }
        },
    ],
};
